import { combineReducers } from 'redux';
import userReducer from 'store/user/userReducer';
import registerUserReducer from './register/registerReducer';
import getCityReducer from './getCity/getCityReducer';
import registerStartReducer from './registerGetStart/registerGetStartReducer';
import registerUploadReducer from './registerUpload/registerUploadReducer';
import registerProviderTypeReducer from './registerProviderType/registerProviderTypeReducer';
import registerTitleReducer from './registerTitle/registerTitleReducer';
import registerQualificationReducer from './registerQualification/registerQualificationReducer';
import registerOneReducer from './registerStepOne/registerStepOneReducer';
import getReviewDetailReducer from './registerReview/registerReviewReducer';
import registerVerifyReducer from './registerVerify/registerVerifyReducer';
import getPracticeReducer from './registerPractice/registerPracticeReducer';
import registerProfessionalReducer from './registerProfessional/registerProfessionalReducer';
import registerFinalReducer from './registerFinal/registerFinalReducer';
import loginReducer from './login/LoginReduecer';
import getScheduleReducer from './getSchedule/getScheduleReducer';
import loginVerifyReducer from './verifyNumber/verifyNumberReducer';
import doctorLogoutReducer from './doctorLogout/doctorLogoutReducer';
import profileDataReducer from './doctorProfile/doctorProfileReducer';
import getScheduleDetailReducer from './getScheduleDetail/getScheduleDetailReducer';
import getMasterDataReducer from './masterData/masterDataReducer';
import createAvailReducer from './createAvailablity/createAvailablityReducer';
import updateAvailReducer from './updateAvailablity/updateAvailablityReducer';
import getAppointmentReducer from './getAppointment/getAppointmentReducer';
import getAppointmentUpcomigReducer from './getAppointment/getUpcomingAppointment/getUpcomingAppointmentReducer';
import getAppointmentDetailReducer from './getAppointmentDetail/getAppointmentDetailReducer';
import updateRequestDetailReducer from './updateRequestStatus/updateRequestStatusReducer';
import getVedioCallReducer from './VedioCallToken/vedioCallTokenReducer';
import getDashboardReducer from './dashboard/dashboardReducer';
import postPendingReducer from './createPendingDetail/createPendingDetailReducer';
import getPatientReducer from './getPatient/getPatientReducer';
import getPatientDetailReducer from './getPatientDetail/getPatientDetailReducer';
import profileSectionDataReducer from './doctorProfileSection/doctorProfileSectionReducer';
import updateProfileSectionDataReducer from './updateDoctorProfile/updateDoctorProfileReducer';
import getSuggestSlotDataReducer from './getSuggestSlot/getSuggestSlotReducer';
import getProductListReducer from './productList/productListReducer';
import basicDetailsValueReducer from './BasicDetailValues/BasicDetailValuesReducer';
import getSubscriptionReducer from './subscriptionPlan/subscriptionPlanReducer';
import postPurchaseReducer from './purchaseDoctor/purchaseDoctorReducer';
import postCancelReducer from './cancelSubscription/cancelSubscriptionReducer';
import deleteDoctorReducer from './deleteDoctor/deleteDoctorReducer';
import getContractFileReducer from './getContractFile/getContractFileReducer';
import addContractFileReducer from './addContractFile/addContractFileReducer';
import getConsultationHistoryReducer from './getConsultationHistory/getConsultationHistoryReducer';
import deleteRegisterProfessionalCategoryReducer from './deleteRegisterProfessionalCategory/deleteRegisterProfessionalCategoryReducer';
import downloadConsultationHistoryReducer from './downloadConsultationHistory/downloadConsultationHistoryReducer';
import getReminderReducer from './getReminder/reducer';
import updateSubpracticeInfoReducer from './updateSubpracticeInfo/reducer';
import markHolidayReducer from './markHoliday/reducer';
import getScheduleDateDetailReducer from './getScheduleDateDetail/reducer';

export default combineReducers({
  userReducer,
  loginReducer,
  loginVerifyReducer,
  registerUserReducer,
  getCityReducer,
  registerStartReducer,
  registerUploadReducer,
  registerProviderTypeReducer,
  registerTitleReducer,
  registerQualificationReducer,
  registerOneReducer,
  getReviewDetailReducer,
  registerVerifyReducer,
  getPracticeReducer,
  registerProfessionalReducer,
  registerFinalReducer,
  basicDetailsValueReducer,
  profileDataReducer,
  getMasterDataReducer,
  getDashboardReducer,
  getScheduleReducer,
  getScheduleDetailReducer,
  createAvailReducer,
  updateAvailReducer,
  getAppointmentReducer,
  getAppointmentUpcomigReducer,
  getAppointmentDetailReducer,
  getSuggestSlotDataReducer,
  updateRequestDetailReducer,
  getVedioCallReducer,
  getProductListReducer,
  postPendingReducer,
  getPatientReducer,
  getPatientDetailReducer,
  profileSectionDataReducer,
  updateProfileSectionDataReducer,
  getSubscriptionReducer,
  postPurchaseReducer,
  postCancelReducer,
  doctorLogoutReducer,
  deleteDoctorReducer,
  getContractFileReducer,
  addContractFileReducer,
  getConsultationHistoryReducer,
  deleteRegisterProfessionalCategoryReducer,
  downloadConsultationHistoryReducer,
  getReminderReducer,
  updateSubpracticeInfoReducer,
  markHolidayReducer,
  getScheduleDateDetailReducer,
});
